const permisos = {
    ObtenerSecciones: 'SICPO/PaginaWeb/Administracion/Permisos/ObtenerSecciones',
    ObtenerUsuarios: 'SICPO/PaginaWeb/Administracion/Permisos/ObtenerUsuarios',
    GuardarSeccionesUsuarios: 'SICPO/PaginaWeb/Administracion/Permisos/GuardarSeccionesUsuarios',
    GuardarPermisosAPlataformaSICPO: 'SICPO/PaginaWeb/Administracion/Permisos/GuardarPermisosAPlataformaSICPO',
    ObtenerSeccionesDeUsuario: 'SICPO/PaginaWeb/Administracion/Permisos/ObtenerSeccionesDeUsuario'
}

export default permisos;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPO/sistema/paginaweb/permisos/permisos.js
// module id = null
// module chunks = 